module.exports = __webpack_public_path__ + "img/trasporto.758e200f.png";